import { render } from "./SiteCycleComponent.vue?vue&type=template&id=975b86cc"
import script from "./SiteCycleComponent.vue?vue&type=script&lang=js"
export * from "./SiteCycleComponent.vue?vue&type=script&lang=js"

import "./SiteCycleComponent.vue?vue&type=style&index=0&id=975b86cc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__